<div class="title">
  <mat-icon>person</mat-icon>
  Ownership
</div>
<div class="description">SELECT THE OWNERS TO FILTER BY</div>

<div class="options">
  <elements-filter-chip
    icon="person"
    [caption]="owner.displayName"
    [selected]="isSelected(owner)"
    *ngFor="let owner of owners$ | async"
    (click)="isSelected(owner) ? remove(owner) : add(owner)"
    [suffixIcon]="isSelected(owner) ? 'close' : undefined"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
